import styled from '@emotion/styled';

export const ThemeSwitcherWrapper = styled.div` 
  display: flex;
  justify-content: center;
  gap:8px;
  margin-bottom: 8px;
`;
